import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Modal from 'react-modal';
export default class SubmitCoachingModal extends Component {
  componentDidMount() {
    Modal.setAppElement("#root");
  }
  render() {
    const {
      showModal,
      handleSubmit,
      handleCloseModal,
    } = this.props;


    return (
      <Modal     
        isOpen={showModal}
        contentLabel='Submit Coaching'
        onRequestClose={handleCloseModal}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        className='submit-coaching-modal'
      >
        
        <div className='submit-modal-header'>
          Submit Coaching
        </div>
        <div className='submit-modal-body'>
          Are you sure you want to submit? Once submitted, you will not be able to modify.
        </div>
        <div className='submit-modal-footer'>
          <button
            type="button"
            onClick={handleCloseModal}
            className='modal-btn modal-btn__no'>
              No
          </button>
          <button
            type="button"
            onClick={() => {
              handleSubmit();
              handleCloseModal();
            }}
            className='modal-btn modal-btn__yes'
          >
            Yes
          </button>
        </div>
      </Modal>
    );
  }
}

SubmitCoachingModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
}

SubmitCoachingModal.defaultProps = {
  showModal: null,
  handleSubmit: null,
  handleCloseModal: null,
}


// WEBPACK FOOTER //
// ./src/features/agent-coaching/SubmitCoachingModal.js